import React from "react";
import "./Dwounload_lottie.css";
import Lottie from "lottie-react";
import downloadAnimation from "./Dounload.json"; // Update the path

function Dwounload_lottie() {
  return (
    <div className="Dwounload_lottie">
      <Lottie animationData={downloadAnimation} loop={true} />
    </div>
  );
}

export default Dwounload_lottie;
